<template>
  <div class="ml-4 my-4">
    <!-- <b>
      {{ $t("ShareModal.DOWNLOAD") }}
    </b>
    -->
    <!--
    <div class="columns is-vcentered mb-0">
      <div class="column">
        <span>
          {{ $t("ShareModal.DOWNLOAD_OFFLINE") }}
        </span>
      </div>

      <b-button
        type="is-info is-light"
        icon-left="download"
        style="vertical-align: middle"
        @click="download(false, false)"
      >
        {{ $t("ShareModal.FULL_ZIP") }}
        <b-loading
          v-model="isLoading"
          :can-cancel="false"
          :is-full-page="isFullPage"
        ></b-loading>
      </b-button>

      <b-button
        type="is-info is-light"
        icon-left="download"
        style="vertical-align: middle"
        @click="download(true, false)"
      >
        {{ $t("ShareModal.HTML_ONLY") }}
        <b-loading
          v-model="isLoading"
          :can-cancel="false"
          :is-full-page="isFullPage"
        ></b-loading>
      </b-button>
    </div>
    -->
    <div class="columns is-vcentered">
      <div class="column">
        <span>
          {{ $t("ShareModal.DOWNLOAD_LMS") }}
        </span>
      </div>

      <b-button
        type="is-info is-light"
        icon-left="download"
        style="vertical-align: middle"
        @click="downloadSCORM()"
      >
        SCORM
        <b-loading
          v-model="isLoading"
          :can-cancel="false"
          :is-full-page="isFullPage"
        ></b-loading>
      </b-button>
    </div>
  </div>
</template>

<script>
import SequenceDataService from "../../src/services/SequenceDataService";

//ELEDA OBJECTS
import { Sequence } from "../../eleda4teachers/src/modules/Sequence.js";
import { convertJSONWorkspaceIntoJSCode } from "../../eleda4teachers/src/modules/utils/blockly/Utils-Blockly.js";
import { frontendURL } from "../config/settings-network.mjs";

import { shuffleArray } from "../../eleda4teachers/src/modules/utils/numeric/Utils-List.mjs";

import b64ToBlob from "b64-to-blob";

import JSZip from "jszip";
import { saveAs } from "file-saver";
import {
  generateSCORMHtmlContent,
  generateSCORMImsManifestContent,
} from "../config/settings-scorm.mjs";

export default {
  name: "OfflineDownload",

  props: {
    sequenceId: {
      type: Number,
      default: null,
    },
    sequenceName: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      isLoading: false,
      isFullPage: true,
      pseudoSequence: true,
      isSequenceLoading: false,
      currentSequence: {
        id: null,
        name: "",
        //  feedbackProvided: true,
        solutionProvided: true,
        reviewProvided: true,
        userId: null,
        activities: [],
        isRandom: false,
        isTimed: false,
        timer: null,
      },
      workspace: null,
      structureActivities: [] /*
      [{id : idActivity, 
        xml : xmlActivity,
        lang : [...],
        sequenceActivity : {repetitions : 2,maxAttempts:1}
        },{id ...} 
      ]*/,
      currentIndiceStructureActivities: -1,
      sequenceEleda: null,
      allGrades: null,
      timerCount: null,
      isHTMLOnly: false,
      url: frontendURL,
      isSCORM: false,
    };
  },

  mounted() {
    console.log("OfflineDownload mounted");
    console.log("OfflineDownload: id", this.$props.sequenceId);
    console.log("OfflineDownload: name", this.$props.sequenceName);
  },

  methods: {
    download(isHTMLOnly, isSCORM) {
      this.isHTMLOnly = isHTMLOnly;
      this.isSCORM = isSCORM;

      console.log("download");
      this.getJsCode();
    },

    /**Download SCORM as iframe */
    downloadSCORM() {
      console.log("sequenceName", this.$props.sequenceName);

      const zip = new JSZip();

      // Ajouter le fichier imsmanifest.xml
      zip.file(
        "imsmanifest.xml",
        generateSCORMImsManifestContent(this.$props.sequenceName)
      );

      // Ajouter le fichier HTML avec l'iframe
      zip.file(
        "index.html",
        generateSCORMHtmlContent(
          this.$props.sequenceName,
          this.url,
          "/sequence/" + this.$props.sequenceId + "?SCORM=true"
        )
      );

      // Générer et télécharger le fichier ZIP
      const instance = this;
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, "scorm_eleda_" + instance.$props.sequenceName + ".zip");
      });
    },

    getJsCode() {
      this.pseudoSequence = false;

      //console.log("pseudoSequence", this.$route.params.pseudoSequence);
      if (this.pseudoSequence) {
        this.generatePseudoSequenceFromRoute();
      } else {
        this.dbGetLoadSequence(this.$props.sequenceId);
      }
    },

    generatePseudoSequenceFromRoute() {
      //Get sequence settings from URL
      console.log("generatePseudoSequenceFromRoute");
      this.currentSequence.name = "Pseudo Sequence";
      /*  if (this.$route.params.feedbackProvided) {
        this.currentSequence.feedbackProvided =
          this.$route.params.feedbackProvided === "true";
      }*/
      if (this.$route.params.solutionProvided) {
        this.currentSequence.solutionProvided = Boolean(
          this.$route.params.solutionProvided
        );
      }
      if (this.$route.params.reviewProvided) {
        this.currentSequence.reviewProvided = Boolean(
          this.$route.params.reviewProvided
        );
      }
      this.dbGetLoadActivity(Number(this.$route.params.id));
    },

    dbGetLoadSequence(id) {
      this.isSequenceLoading = true;
      SequenceDataService.getEditWithXml(id)
        .then((response) => {
          this.currentSequence.id = response.data.id;
          this.currentSequence.name = response.data.name;

          document.title = this.currentSequence.name + " - Eleda";

          //    this.currentSequence.feedbackProvided =    response.data.feedbackProvided;
          this.currentSequence.solutionProvided =
            response.data.solutionProvided;
          this.currentSequence.reviewProvided = response.data.reviewProvided;
          this.currentSequence.userId = response.data.userId;
          this.currentSequence.activities = response.data.activities;
          this.currentSequence.isRandom = response.data.isRandom;
          this.currentSequence.isTimed = response.data.isTimed;
          this.currentSequence.timer = response.data.timer;
          this.timerCount = this.currentSequence.timer * 60;
          if (this.currentSequence.isTimed) {
            this.currentSequence.solutionProvided = false;
          }

          this.$buefy.snackbar.open({
            message: "Séquence chargée !",
            duration: 500,
            type: "is-warning",
            position: "is-top",
            actionText: null,
          });
          this.generateStructure();
          this.isSequenceLoading = false;
        })
        .catch((e) => {
          console.log(e);
          this.showToast("Error when loading sequence", "is-danger");
          this.isSequenceLoading = false;
        });
    },

    generateStructure() {
      this.currentSequence.activities = this.currentSequence.activities.sort(
        (firstActivity, secondActivity) =>
          firstActivity.sequenceActivity.order -
          secondActivity.sequenceActivity.order
      );
      this.currentSequence.activities.forEach((activity) => {
        var code = convertJSONWorkspaceIntoJSCode(activity.xml).jsCode;
        //Empty currentSequence activities xml to free memory
        this.structureActivities.push(
          ...Array(activity.sequenceActivity.repetitions).fill({
            id: activity.id,
            code: code,
            name: activity.name,
            coefficient: activity.sequenceActivity.coefficient,
          })
        );
      });
      //After traitment Empty currentSequence activities xml to free memory
      //To avoid offline generates a huge html file with blockly xml usefullless
      this.currentSequence.activities.forEach(
        (activity) => delete activity.xml
      );
      if (this.currentSequence.isRandom) {
        shuffleArray(this.structureActivities);
      }
      this.sequenceEleda = new Sequence(this.structureActivities.length, {
        //  feedbackProvided: this.currentSequence.feedbackProvided,
        solutionProvided: this.currentSequence.solutionProvided,
        reviewProvided: this.currentSequence.reviewProvided,
      });

      //TO TONY : Une fois impélémenté la fonction (déroulement random) mélanger les éléments du Array avec la méthode Utils adhoc
      this.nextActivity();
      this.downloadSequenceOffline(
        this.currentSequence.name,
        this.isSCORM,
        this.isHTMLOnly
      );
    },

    nextActivity() {
      if (
        this.currentIndiceStructureActivities <
        this.structureActivities.length - 1
      ) {
        this.currentIndiceStructureActivities++;
      } else {
        console.log(this.allGrades);
      }
    },

    downloadSequenceOffline(name, isScorm, isHTMLOnly) {
      //On lance un loading screen le temps du traitement
      this.isFullPage = true;
      this.isLoading = true;

      let data = {
        currentSequence: this.currentSequence,
        structureActivities: this.structureActivities,
        pseudoSequence: false,
        isScorm: isScorm,
        isHTMLOnly: isHTMLOnly,
      };

      //On envoie dans la requête les paramètres de la séquence pour qu'ils soit pris en compte dans notre fichier zip
      SequenceDataService.zipSequenceOffline(data).then((response) => {
        //On convertie le fichier en base64, en fichier zip

        const blob = b64ToBlob(response.data, "application/zip");

        //On enregistre le fichier sur la machine local grace à fileSaver
        //On donne le nom de l'activité (filename) au fichier zip

        fileSaver.saveAs(blob, name.replace(/['"]+/g, "") + ".zip");

        //On stop le loading screen
        this.isLoading = false;
        this.isFullPage = false;
      });
    },
  },
};
</script>
